<template>
  <div class="scanner-container">

    <!--    摄像背景：-->
    <video ref="video" style="object-fit: contain;" width="100vw" height="100vh" id="video" class="scan-video"
      autoplay></video>

    <!-- Canvas 背景 -->
    <canvas ref="canvas" class="canvas-background" style="display: none;"></canvas>


    <!--    摄像背景：-->
    <!-- <video v-show="!isPaused" ref="video" style="object-fit: fill;" width="100vw" height="100vh" id="video"
      class="scan-video" autoplay></video> -->

    <!-- Canvas 背景 -->
    <!-- <canvas v-show="!!isPaused" ref="canvas" class="canvas-background"></canvas> -->

    <!-- 扫描框 -->
    <div class="scan-frame" :style="scanFrameStyle">
      <div class="scan-box"></div>
    </div>

    <!-- 底部提示、拍照按钮 -->
    <div class="scan-tip">
      <div class="tip">
        <span>请对准序列号、串号拍照</span>
        <div class="photos">
          <van-image :src="photos" @click="openFileDialog" fit="cover" round width="1.2rem" height="1.2rem" />
          <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" ref="fileInput"
            @change="handleFileChange" style="display: none;" />
          <span>相册选取</span>
        </div>
      </div>
      <!-- 1rem = 16px -->
      <van-icon @click="take_pic(null)" name="stop-circle-o" size="1.6rem" />
    </div>

    <van-dialog id="van-dialog" />
    <van-dialog v-model="show" show-cancel-button :showConfirmButton="false" :showCancelButton="false">
      <div class="poup-class">
        <div class="_item" @click="set_code(code)" v-for="(code, index) in data" :key="index">{{code}}</div>
      </div>
      <template #buttons>
        <van-button type="primary" @click="onConfirm">确认</van-button>
      </template>
    </van-dialog>
  </div>
</template>

<script>
  import {
    Button,
    Dialog
  } from 'vant'
  import {
    BrowserMultiFormatReader
  } from '@zxing/library'
  import {
    base64ToFormData
  } from '@/utils'
  import axios from 'axios'

  import {
    getImgScanCode
  } from "@/api/index"

  export default {
    components: {
      [Button.name]: Button
    },
    data() {
      return {
        photos: require('@/assets/photos.png'),
        isPaused: false,
        codeReader: null,
        // 扫描框的位置和尺寸
        scanFrame: {
          width: 0, // 动态计算
          height: 42, // 固定高度
          left: 0, // 动态计算
          top: 0 // 动态计算
        },
        fileInput: null,
        data: null, // 接口返回的条码
        show: false,
        code_type: 1, // 1-激活码 2-串号
        type: 0, // 0.识别IMEI和识别序列号 1.识别激活码
        ind: 0 // 激活码有3个 这是当前激活码的下标
      }
    },
    computed: {
      // 动态计算扫描框的样式
      scanFrameStyle() {
        return {
          width: `${this.scanFrame.width}px`,
          height: `${this.scanFrame.height}px`,
          left: `${this.scanFrame.left}px`,
          top: `${this.scanFrame.top}px`
        }
      }
    },

    watch: {
      '$route'(to, from) {
        if (to.path == '/scanCodePage') { // 当处于该页面时
          this.openScan()
        }
      }
    },

    mounted() {
      window.document.title = '拍照识别'
      this.code_type = this.$route.query.code_type
      this.ind = this.$route.query.ind ? this.$route.query.ind : 0
      this.type = this.code_type==2? 0:1

      this.fileInput = this.$refs.fileInput

      // 动态设置扫描框的位置和尺寸
      this.setScanFramePosition()

      // 监听窗口大小变化
      window.addEventListener('resize', this.setScanFramePosition)

      // 在 DOM 渲染完成后打开摄像头
      this.$nextTick(() => {
        this.openScan()
      })
    },

    methods: {

      openFileDialog() {
        this.$refs.fileInput.click()
      },

      handleFileChange(e) {
        const file = e.target.files[0]
        console.log('file -- - - ', file)
        if (file) {
          this.send_post(null, file)
        }
      },

      // 点击拍照
      async take_pic() {
        await this.pause()
      },

      // 暂停摄像画面
      async pause() {
        const video = this.$refs.video
        const canvas = this.$refs.canvas
        if (!video || !canvas) return
        // 确保视频帧已渲染
        if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
          this.$toast('视频帧未准备好，请稍后重试')
          return
        }
        console.log(video.offsetWidth, video.offsetHeight, video.width, video.height);
        // 绘制最后一帧到 canvas
        canvas.width = video.offsetWidth
        canvas.height = video.offsetWidth * 0.7655172413793103
        // 使用 requestAnimationFrame 确保绘制时机
        requestAnimationFrame(async () => {
          const ctx = canvas.getContext('2d')
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          // ctx.drawImage(video, 0, 0, 390, 390)

          // 隐藏视频，显示 canvas
          video.style.display = 'none'
          canvas.style.display = 'block'

          // 暂停视频显示
          // this.isPaused = true

          // 暂停 ZXing 解码
          // this.codeReader.reset()
          // 扫描区域截图 --- 必须写在这
          await this.capture()
        })
      },

      // 扫描区域截图功能
      async capture() {

        const video = this.$refs.video
        const canvas = this.$refs.canvas


        console.log("canvas - ", canvas);
        const rect = canvas.getBoundingClientRect();
        const topDistance = rect.top;
        console.log(`canvas 距离屏幕顶部的距离是: ${topDistance}px`);
        const leftDistance = rect.left;
        console.log(`canvas 距离屏幕左侧的距离是: ${leftDistance}px`);

        // const ctx = canvas.getContext('2d')

        // 创建新的 Canvas 用于截取扫描框区域
        const croppedCanvas = document.createElement('canvas')
        const croppedCtx = croppedCanvas.getContext('2d')

        // 设置截取 Canvas 的尺寸为扫描框大小
        croppedCanvas.width = this.scanFrame.width
        croppedCanvas.height = this.scanFrame.height

        // console.log("this.scanFrame.left - ", this.scanFrame.left);
        // console.log("this.scanFrame.top - ", this.scanFrame.top);
        // console.log("this.scanFrame.width - ", this.scanFrame.width);
        // console.log("this.scanFrame.height - ", this.scanFrame.height);

        // 截取扫描框区域
        croppedCtx.drawImage(
          canvas,
          this.scanFrame.left, // 源图像的 x 坐标
          this.scanFrame.top - topDistance, // 源图像的 y 坐标
          this.scanFrame.width, // 截取宽度
          this.scanFrame.height, // 截取高度
          0, 0, // 目标 Canvas 的起始坐标
          this.scanFrame.width, // 目标 Canvas 的宽度
          this.scanFrame.height // 目标 Canvas 的高度
        )
        // croppedCtx.drawImage(
        //   canvas,
        //   this.scanFrame.left, // 源图像的 x 坐标
        //   this.scanFrame.top, // 源图像的 y 坐标
        //   this.scanFrame.width, // 截取宽度
        //   this.scanFrame.height, // 截取高度
        //   0, 0, // 目标 Canvas 的起始坐标
        //   this.scanFrame.width, // 目标 Canvas 的宽度
        //   this.scanFrame.height // 目标 Canvas 的高度
        // )

        // 将截取的内容转换为 Base64 图片
        const base64 = croppedCanvas.toDataURL('image/png')
        console.log('截取的图片:', base64)
        // return

        // 发送请求
        await this.send_post(base64)
      },

      // 发送数据请求
      send_post(base64, File) {
        let formData = null
        if (base64) {
          formData = base64ToFormData(base64, 'code_img')
        } else if (File) {
          formData = new FormData()
          formData.append('file', File, 'code_img')
        }
        formData.append('type', this.type)



        getImgScanCode(formData)
          .then(async response => {
            this.isPaused = false
            this.flag = false

            console.log('Image uploaded successfully', response)
            // response.data.data = ['8888888888']
            const data = response.data.data

            if (data.length == 0) {
              this.show_tips(response.data.msg)
            } else if (data.length == 1) {
              this.set_code(data[0])
            } else if (data.length >= 2) {
              this.data = data
              this.show = true
            }

            const video = this.$refs.video
            const canvas = this.$refs.canvas

            video.style.display = 'block'
            canvas.style.display = 'none'

          })
          .catch(error => {
            this.isPaused = false
            this.flag = false
            console.log('error - - - ', error)
            this.error_tips()

            const video = this.$refs.video
            const canvas = this.$refs.canvas

            video.style.display = 'block'
            canvas.style.display = 'none'
          })
      },

      set_code(code) {
        console.log('code - - - ', code)
        if (this.code_type == 1) {
          window.localStorage.setItem('_scanCode_' + this.ind + '_' + this.code_type, code)
          this.$router.replace('/')
        } else if (this.code_type == 2) {
          window.localStorage.setItem('_scanCode_' + this.code_type, code)
          this.$router.replace('/')
        } else if (this.code_type == 3) {
          window.localStorage.setItem('_scanCode_' + this.code_type, code)
          this.$router.replace('/searchCode')
        }
      },

      show_tips(msg) {
        Dialog.alert({
          title: '提示',
          // message: '未识别到序列号或串号，请对准拍清晰',
          message: msg,
          theme: 'round-button',
          confirmButtonText: '知道了'
        }).then(() => {
          // on close
        })
      },

      error_tips() {
        Dialog.alert({
          title: '提示',
          message: '接口报错，请联系管理员',
          theme: 'round-button',
          confirmButtonText: '知道了'
        }).then(() => {
          // on close
        })
      },

      // 动态设置扫描框的位置和尺寸
      setScanFramePosition() {
        const screenWidth = window.innerWidth
        const screenHeight = window.innerHeight
        // 扫描框宽度为屏幕宽度的 90%
        this.scanFrame.width = screenWidth * 0.9
        // 扫描框高度为 78px
        this.scanFrame.height = 78
        // 扫描框距离屏幕顶部 50vh - 39px
        this.scanFrame.top = (screenHeight * 0.5) - (78 / 2)
        // 扫描框左右居中
        this.scanFrame.left = (screenWidth - this.scanFrame.width) / 2
      },

      // 重启动摄像头
      async resume() {
        const video = this.$refs.video
        const canvas = this.$refs.canvas
        if (!video || !canvas) return

        // // 恢复视频显示
        // video.style.display = 'block'
        // canvas.style.display = 'none'

        // 重新启动 ZXing 解码
        this.decodeFromInputVideoFunc(null)
        this.isPaused = false
      },

      // 初始化打开摄像头
      openScan() { // 初始化摄像头
        this.codeReader = new BrowserMultiFormatReader()
        this.codeReader.getVideoInputDevices()
          .then((videoDevices) => {
            console.log('get-videoDevices', videoDevices)
            
            if (!videoDevices || videoDevices.length === 0) {
              this.$toast.fail('未找到可用的摄像头设备')
              return
            }

            // 默认获取摄像头列表里的最后一个设备id，通过几部测试机发现一般前置摄像头位于列表里的前面几位，所以一般获取最后一个的是后置摄像头
            let firstDeviceId = videoDevices[videoDevices.length - 1].deviceId
            // 一般获取了手机的摄像头列表里不止一个，有的手机摄像头高级多层，会有变焦摄像头等情况，需要做处理
            if (videoDevices.length > 1) {
              // 一般通过判断摄像头列表项里的 label 字段，'camera2 0, facing back' 字符串含有 'back' 和 '0'，大部分机型是这样，如果有些机型没有，那就还是默认获取最后一个
              const backCamera = videoDevices.find(el => {
                return el.label.indexOf('back') > -1 && el.label.indexOf('0') > -1
              })
              firstDeviceId = backCamera ? backCamera.deviceId : videoDevices[videoDevices.length - 1].deviceId
            }
            console.log('get-firstDeviceId', firstDeviceId)

            this.decodeFromInputVideoFunc(firstDeviceId)
          })
          .catch((err) => {
            console.error('打开摄像头失败:', err)
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
              this.$toast.fail('摄像头权限被拒绝，请在浏览器设置中允许访问摄像头')
            } else if (err.name === 'NotFoundError') {
              this.$toast.fail('未找到可用的摄像头设备')
            } else {
              this.$toast.fail('打开摄像头失败：' + (err.message || '未知错误'))
            }
          })
      },
      decodeFromInputVideoFunc(firstDeviceId) { // 使用摄像头扫描
        this.codeReader.reset() // 重置
        // 使用传入的设备ID打开摄像头
        this.codeReader.decodeFromInputVideoDeviceContinuously(firstDeviceId, 'video', (result, err) => {
          if (err) {
            console.error('扫描错误:', err)
          }
        })
      },

      // 下载图片（可选）
      downloadImage(base64, filename) {
        const link = document.createElement('a')
        link.href = base64
        link.download = filename
        link.click()
      }
    },
    beforeDestroy() {
      // 移除窗口大小变化监听
      window.removeEventListener('resize', this.setScanFramePosition)
    },
    destroyed() {
      this.codeReader.reset()
      this.codeReader = null
    }
  }
</script>

<style lang="less" scoped>
  .scanner-container {
    position: relative;
    width: 100vw;
    /* 容器宽度为屏幕宽度 */
    height: 100vh;
    /* 容器高度为屏幕高度 */
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: #000;
  }

  .scan-video {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #000;
  }

  .canvas-background {
    position: absolute;
    top: 50%;
    left: 50%;
    // width: 100%;
    // height: 100%;
    transform: translate(-50%, -50%);

  }

  .scan-frame {
    position: absolute;
    border: 2px solid #07c160;
    box-shadow: 0 0 20px rgba(7, 193, 96, 0.3);
    // background: rgba(0, 0, 0, 0.3);
    // background: rgba(0, 0, 0, 0);
    background-color: transparent;
    z-index: 2;
  }

  .scan-box {
    width: 100%;
    height: 1px;
    // height: 100%;
    animation: scan 2s infinite linear;
    // border: 1px solid rgba(7, 193, 96, 0.5);
    background-color: rgba(7, 193, 96, 0.5);
    position: absolute;
    top: 0;
  }

  @keyframes scan {
    0% {
      top: 0;
      transform: translateY(-100%);
    }

    50% {
      top: 100%;
    }

    100% {
      top: 0;
      transform: translateY(100%);
    }
  }

  .controls {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }

  .scan-tip {
    width: 100vw;
    // height: 20vh;
    height: 22vh;
    text-align: center;
    color: white;
    font-size: 5vw;
    background-color: transparent;
    position: absolute;
    bottom: 0.3rem;
    left: 0;
    box-sizing: border-box;
    padding-top: 1rem;

    z-index: 3;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    color: #FFF;
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;

    .tip {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      margin-bottom: 10px;
      position: relative;

      .photos {
        position: absolute;
        top: -5px;
        right: 1rem;
        // width: 50px;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        /deep/ .van-image {
          margin-bottom: 0.2rem;
        }

        color: #FFF;
      }

    }
  }

  /deep/ .poup-class {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 1rem;
    box-sizing: border-box;

    ._item {
      width: 100%;
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      box-sizing: border-box;
      border: 0.5px solid rgb(251, 51, 42);
      border-radius: 8px;
      background: rgb(255, 245, 245);
      margin-bottom: 0.5rem;
      box-sizing: border-box;

      color: #FF1A00;
      font-family: 思源黑体;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: -0.33px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/scan_code_page.vue